import {
  buildUnderlyingsDatesCompositeKey,
  buildUnderlyingsDatesKey,
} from 'state/underlyingsDates/underlyingsDates.utils';
import {
  initialUnderlyingsDatesMapState,
  UnderlyingsDatesMapState,
} from 'state/underlyingsDates/underlyingsDatesState.model';
import { addOrReplaceKey } from 'state/utils/collection';

import { Action } from '../actions';

export function underlyingsDatesReducer(
  state: UnderlyingsDatesMapState = initialUnderlyingsDatesMapState,
  action: Action,
): UnderlyingsDatesMapState {
  switch (action.type) {
    case 'UNDERLYINGS_BLACKOUT_DATES_REQUESTED':
    case 'UNDERLYINGS_SPECIFIC_DATES_REQUESTED':
      const loadingKey = buildUnderlyingsDatesCompositeKey(buildUnderlyingsDatesKey(action.underlyingsDatesPayload));
      return addOrReplaceKey(state, loadingKey, {
        status: 'loading',
      });
    case 'UNDERLYINGS_BLACKOUT_DATES_REQUEST_FAILED':
    case 'UNDERLYINGS_SPECIFIC_DATES_REQUEST_FAILED':
      const errorKey = buildUnderlyingsDatesCompositeKey({
        productType: action.productType,
        productSubType: action.productSubType,
        underlyingBloombergCode: action.underlyingBloombergCode,
      });
      return addOrReplaceKey(state, errorKey, {
        status: 'error',
        error: action.error,
      });
    case 'UNDERLYINGS_BLACKOUT_DATES_RECEIVED':
      const underlyingsBlackoutDatesStateKey = buildUnderlyingsDatesCompositeKey(action.underlyingsDateKey);
      return addOrReplaceKey(state, underlyingsBlackoutDatesStateKey, {
        content: {
          underlyingBloombergCode: action.underlyingBloombergCode,
          blackoutDates: action.blackoutDates,
        },
        status: 'success',
      });
    case 'UNDERLYINGS_SPECIFIC_DATES_RECEIVED':
      const underlyingSpecificDatesStateKey = buildUnderlyingsDatesCompositeKey(action.underlyingsDateKey);
      return addOrReplaceKey(state, underlyingSpecificDatesStateKey, {
        content: {
          underlyingBloombergCode: action.underlyingBloombergCode,
          specificDates: action.specificDates,
        },
        status: 'success',
      });
    default:
      return state;
  }
}
